import React, { FC, useState } from 'react';
import { WelderProgressHeaderStyled, RodRequestHeaderStyled, TabButtonStyled, TreeLineStyled } from './styled';
import { CrewListContainerStyled, CrewListItemStyled, CrewBulletStyled } from '../styled';
import { map } from 'lodash';
import { WelderProgressTreeItem } from './item';
import { RodRequestItem } from './rod-request-item';
import { Text, Box, theme } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { CrewProgressStats } from '@bechtel/types';
import { useModulePermission } from '@bechtel/client-common';

interface WelderProgressTreeProps {
  depth: number;
  craftStats: CrewProgressStats[];
}

export const WelderProgressTree: FC<WelderProgressTreeProps> = ({ depth, craftStats }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { canViewRodRoomModule } = useModulePermission();
  return (
    <Box mr={{ sm: '400' }} mt={{ sm: '300' }} pb={{ sm: '100' }} flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
      <WelderProgressHeaderStyled>
        <TabButtonStyled
          ml={{ sm: '300' }}
          px={{ sm: '450' }}
          py={{ sm: '300' }}
          onClick={() => setSelectedTab(0)}
          isSelected={selectedTab == 0}
          data-testid="welder-progress-tab"
        >
          <Text size="300">
            <Trans>Progress</Trans>
          </Text>
        </TabButtonStyled>
        {canViewRodRoomModule && (
          <TabButtonStyled
            px={{ sm: '450' }}
            py={{ sm: '300' }}
            onClick={() => setSelectedTab(1)}
            isSelected={selectedTab == 1}
            data-testid="rod-request-tab"
          >
            <Text size="300">
              <Trans>Rod Requests</Trans>
            </Text>
          </TabButtonStyled>
        )}
        <TreeLineStyled />
      </WelderProgressHeaderStyled>
      {selectedTab == 1 && (
        <>
          <RodRequestHeaderStyled data-testid="rod-request-header">
            <Text size="300" color="grey.700" style={{ justifySelf: 'left', paddingLeft: '12px' }}>
              <Trans>Welders</Trans>
            </Text>
            <Text size="300" color="grey.700">
              <Trans>Rod Request(s)</Trans>
            </Text>
            <Text size="300" color="grey.700">
              <Trans>Edit</Trans>
            </Text>
            <Text size="300" color="grey.700">
              <Trans>View</Trans>
            </Text>
            <TreeLineStyled />
          </RodRequestHeaderStyled>
          <CrewListContainerStyled style={{ backgroundColor: 'aliceblue' }}>
            {map(craftStats, (stat) => {
              return (
                <CrewListItemStyled key={stat?.crewMember?.id}>
                  {depth != 0 && <CrewBulletStyled data-testid="crew-bullet" />}
                  {/* No need for bullet at the root */}
                  <RodRequestItem
                    crewMember={stat?.crewMember}
                    numRodRequests={stat?.rodRequestStatusStats?.length ? stat?.rodRequestStatusStats[0]?.stats : 0}
                  />
                </CrewListItemStyled>
              );
            })}
          </CrewListContainerStyled>
        </>
      )}
      {selectedTab == 0 && (
        <CrewListContainerStyled
          style={{ backgroundColor: `${theme.colors.blue[100]}` }}
          data-testid="weld-progress-container"
        >
          {map(craftStats, (stat) => {
            return (
              <CrewListItemStyled key={stat?.crewMember?.id}>
                {depth != 0 && <CrewBulletStyled data-testid="crew-bullet" />}
                <WelderProgressTreeItem weldStatsByPersona={stat} />
              </CrewListItemStyled>
            );
          })}
        </CrewListContainerStyled>
      )}
    </Box>
  );
};
